import React from 'react';
import { Countdown } from '../common/Countdown';

export const VoteHeader = ({ ballot, countdownDateUtc, isPaused, isShowBorder }) => {
    return (
        <div className={`${isShowBorder ? "pb-4 border-gray-300 border-b mb-4" : ""}`}>
            <div className="flex flext-start">
                {ballot?.orgLogo &&
                    <div className="flex-none hidden md:block">
                        <img src={ballot.orgLogo} className="mx-auto h-16 max-w-[200px] object-contain" alt={ballot.orgName} />
                    </div>
                }
                <div className={`"pl-0 flex-auto" ${ballot?.orgLogo ? " md:pl-4" : ""}`}>
                    <span className="text-3xl block pb-2">{ballot.orgName}</span>
                    <span className="text-xl">{ballot.name}</span>
                </div>
                {countdownDateUtc &&
                    <div className="flex-none">
                        <Countdown
                            targetDateUtc={countdownDateUtc}
                            isPaused={isPaused} />
                    </div>
                }
            </div>
        </div>
    );
}